import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../../lib/api";
import { ChartBar } from "@phosphor-icons/react";

/** Across every document with an understanding check: the questions operatives get wrong most — the parts of a policy that aren't landing. */
export default function QuizInsightsCard() {
  const [d, setD] = useState(null);
  useEffect(() => { API.get("/hse/quiz/insights").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d || !d.documents_with_quiz || !d.attempts) return null;
  const rows = d.questions.filter(q => q.wrong > 0).slice(0, 5);
  return (
    <div className="bg-card border border-border rounded-lg p-4" data-testid="hse-quiz-insights-card">
      <div className="flex flex-wrap items-center gap-2 mb-2">
        <ChartBar size={16} className="text-primary" />
        <p className="text-sm font-semibold flex-1">Where policies aren't landing</p>
        <span className="text-xs text-muted-foreground" data-testid="hse-quiz-insights-summary">{d.documents_with_quiz} document{d.documents_with_quiz === 1 ? "" : "s"} with a check · {d.attempts} attempt{d.attempts === 1 ? "" : "s"}{d.first_time_pass_pct !== null ? ` · ${d.first_time_pass_pct}% pass first time` : ""}</span>
      </div>
      {rows.length === 0 ? (
        <p className="text-xs text-muted-foreground" data-testid="hse-quiz-insights-empty">Every question answered so far has been answered correctly.</p>
      ) : (
        <ol className="space-y-2">
          {rows.map((q, i) => (
            <li key={`${q.doc_id}-${q.id}`} className="text-xs" data-testid={`hse-quiz-insight-row-${i}`}>
              <div className="flex items-start gap-2">
                <span className={`w-5 h-5 rounded-full font-bold text-[11px] inline-flex items-center justify-center shrink-0 ${q.wrong_pct >= 50 ? "bg-red-100 text-red-700" : "bg-amber-100 text-amber-700"}`}>{i + 1}</span>
                <div className="flex-1 min-w-0">
                  <p className="font-medium leading-snug">{q.question}</p>
                  <p className="text-muted-foreground"><Link to={`/health-safety/docs/${q.doc_id}`} className="text-primary hover:underline">{q.doc_title}</Link> v{q.version}{q.section ? ` · “${q.section}”` : ""}{q.most_picked_wrong ? ` · most picked “${q.most_picked_wrong}”` : ""}</p>
                </div>
                <span className={`font-semibold tabular-nums whitespace-nowrap ${q.wrong_pct >= 50 ? "text-red-600" : "text-amber-600"}`}>{q.wrong_pct}% wrong <span className="font-normal text-muted-foreground">({q.wrong}/{q.answered})</span></span>
              </div>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
